import { Modal } from 'react-bootstrap';

function ShippingCostCountModal({show, setShow, Details}){
    return(
      <>
      <Modal
          size="md"
          show={show}
          onHide={() => setShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
      >
          <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg" style={{ fontSize: '1rem' }}>
            합포장조건 ?
          </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <div width="90%">
               {Details}
              </div>
          </Modal.Body>
      </Modal>
    </>
  )
}
export default ShippingCostCountModal